import { X } from 'lucide-react';
import ioLabsLogo from '../assets/iolabs.svg';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AboutModal = ({ isOpen, onClose }: AboutModalProps) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-40 bg-black bg-opacity-50"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
          {/* Close button */}
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>

          {/* Main Title */}
          <div className="mb-6 text-center">
            <h1 className="text-3xl font-bold text-gray-900">ioTokenServer</h1>
          </div>

          {/* Content */}
          <div className="space-y-4">
            {/* Product Information */}
            <div>
              <p className="text-sm text-gray-600">
                A secure OAuth2 and OpenID Connect token management system for managing external
                provider tokens and credentials.
              </p>
            </div>

            {/* Company Information */}
            <div className="border-t border-gray-200 pt-4">
              <div className="mb-2 flex items-center space-x-2">
                <img src={ioLabsLogo} alt="ioLabs AG" className="h-6" />
                <h3 className="text-lg font-semibold text-gray-900">ioLabs AG</h3>
              </div>
              <div className="space-y-1 text-sm text-gray-600">
                <p>Leading provider of industrial IoT solutions</p>
                <p>Specializing in secure, scalable data management</p>
              </div>
            </div>

            {/* Links */}
            <div className="border-t border-gray-200 pt-4">
              <a
                href="https://iolabs.ch"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:text-blue-700 hover:underline"
              >
                Visit iolabs.ch
              </a>
            </div>

            {/* Version info (optional) */}
            <div className="border-t border-gray-200 pt-4 text-xs text-gray-500">
              <p>Version 1.0.0</p>
              <p>&copy; {new Date().getFullYear()} ioLabs AG. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
